module.exports = __webpack_public_path__ + "img/s7IconOpen.973f8918.svg";